import {
  useSummaryController,
  UseSummaryControllerProps,
} from './hooks/use-summary-controller';
import { SummaryProvider } from './summary-provider';
import { SummaryDisplayProps, SummaryDisplay } from './summary-display';
import { memoClassNames } from '@/utils';

const classes = memoClassNames('Summary', ['root']);
export type SummaryProps = UseSummaryControllerProps & SummaryDisplayProps;

export function Summary({
  reference,
  onReceiveFeedback,
  selectSummary,
  className = '',
  ...others
}: SummaryProps) {
  const controller = useSummaryController({
    reference,
    onReceiveFeedback,
    selectSummary,
  });

  return (
    <SummaryProvider controller={controller}>
      <SummaryDisplay className={`${classes.root} ${className}`} {...others} />
    </SummaryProvider>
  );
}
